import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';

import { IconButton } from 'components/Button/IconButton';

import { ActionButton } from '../../../../components/ActionButton';
import { StyledActionButtonSmall } from '../../../../components/ActionButton/styles';

export const StyledCrmExportButton = styled(ActionButton)`
  margin-right: 6px;
`;

export const StyledCrmExportBulkButton = styled(IconButton)`
  font-size: 10.5px;
  line-height: 15px;
  padding: 8px 13px;
`;

export const StyledCrmExportButtonSmall = styled(StyledActionButtonSmall)`
  margin-right: 6px;
`;

export const StyledCrmLink = styled.a`
  display: block;
  height: 100%;
`;

export const StyledCrmExportIcon = styled(SWReactIcons)`
  margin-right: 6px;
`;
